var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useFetch, usePromise, useStateWithMutators } from '@rad/hooks';
import { getJson } from '@rad/utility/http';
import { withPromise } from '@rad/utility/promise';
import { postObjectJson } from '../../utility/request';
import Card from '../components/card';
import Button from '../components/button';
import CInput from '../components/input';
import CErrors from '../components/errors';
export default (props) => {
    const [isosP] = useFetch(getJson('/isos'));
    const isos = usePromise(isosP);
    const [state, mutators] = useStateWithMutators({
        'forms': {
            'iso': {
                'loading': false,
                'error': null,
                'name': '',
                'link': '',
                'iso_code': '',
            },
        },
    });
    const isoCreate = () => withPromise(() => mutators.forms.iso.loading(true), () => mutators.forms.iso.loading(false), () => __awaiter(void 0, void 0, void 0, function* () {
        mutators.forms.iso.error(null);
        yield postObjectJson('/isos/create', state.forms.iso, {
            'success': () => { window.location.hash = '#/'; },
            'error': (x) => __awaiter(void 0, void 0, void 0, function* () { return mutators.forms.iso.error(yield x.json()); }),
        });
    }));
    return _jsx(_Fragment, { children: _jsxs("div", { className: "d-flex w-100", children: [_jsx("div", { className: "column-2", children: _jsx(Card, { title: "ISOs", children: _jsxs("table", { className: "table table-sm table-striped", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Name" }), _jsx("th", { children: "Reseller Code" })] }) }), _jsx("tbody", { children: isos === null || isos === void 0 ? void 0 : isos.map((iso) => _jsxs("tr", { children: [_jsx("td", { children: _jsx("a", { href: `#/admin/isos/${iso.id}`, children: iso.name }) }), _jsx("td", { children: _jsx("code", { children: iso.iso_code }) })] }, iso.id)) })] }) }) }), _jsx("div", { className: "column", children: _jsx(Card, { title: "Create ISO", children: _jsxs("form", { onSubmit: (e) => { e.preventDefault(); isoCreate(); }, children: [_jsx(CErrors, { errors: state.forms.iso.error }), _jsx(CInput, { type: "text", value: state.forms.iso.name, onChange: mutators.forms.iso.name, required: true, children: "Name" }), _jsx(CInput, { type: "text", value: state.forms.iso.iso_code, onChange: mutators.forms.iso.iso_code, required: true, children: "Reseller Code" }), _jsx("div", { className: "text-center mb-2", children: _jsx(Button, { submit: true, color: "primary", disabled: state.forms.iso.loading, children: state.forms.iso.loading ? 'Loading...' : 'Submit' }) })] }) }) })] }) });
};
